/*
  Widerrufsfunktion nach § 356a BGB — Begleitmodul zu sections/widerruf-funktion.liquid

  Das Formular funktioniert vollstaendig ohne dieses Modul: alle Felder sind
  echte Formularfelder, die Erklaerung steht serverseitig vorformuliert im
  Textfeld, und der Absendevorgang ist ein gewoehnlicher POST. Das Modul
  fuegt nur Komfort hinzu und darf nie Voraussetzung fuer die Ausuebung des
  Widerrufsrechts werden.

  Drei Aufgaben:
  1. Die Erklaerung aus den Feldern zusammensetzen, solange der Verbraucher
     nicht selbst hineingeschrieben hat.
  2. Das Positionsfeld ein- und ausblenden (Teilwiderruf, Abs. 2 Nr. 2).
  3. Nach dem Absenden eine Kopie fuer die Unterlagen anbieten. Diese Kopie
     ist ausdruecklich NICHT die Eingangsbestaetigung nach Abs. 4 — die
     schuldet der Haendler auf einem dauerhaften Datentraeger. Deshalb steht
     im Text nirgends "Bestaetigung" oder "Nachweis", und der Zeitstempel
     ist als Geraetezeit des Verbrauchers ausgewiesen.
*/
(function () {
  'use strict';

  var SPEICHER = 'rc-widerruf-kopie';

  function init(wurzel) {
    var form = wurzel.querySelector('form');
    if (form) {
      erklaerungKoppeln(wurzel);
      umfangKoppeln(wurzel);
      kopieMerken(wurzel, form);
    }
    kopieZeigen(wurzel);
  }

  /* ---------- 1. Erklaerungstext ---------- */

  function feld(wurzel, name) {
    return wurzel.querySelector('[data-widerruf-feld="' + name + '"]');
  }

  function wert(el) {
    if (!el) return '';
    if (el.type === 'checkbox') return el.checked ? el.value : '';
    return (el.value || '').trim();
  }

  function datumLesbar(iso) {
    // <input type="date"> liefert immer JJJJ-MM-TT, unabhaengig von der
    // Anzeige im Browser. Fuer die Erklaerung in TT.MM.JJJJ umformen.
    var t = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso || '');
    return t ? t[3] + '.' + t[2] + '.' + t[1] : '';
  }

  /*
    Alle Beschriftungen kommen aus dem gerenderten DOM, nicht aus Literalen
    im Modul: der Einleitungssatz aus `defaultValue` der Textarea (dort steht
    der serverseitig uebersetzte `rc.widerruf.statement_default`), die
    Umfangsangabe aus dem `value` des gewaehlten Radios und die Feldnamen aus
    den zugehoerigen `<label>`-Elementen. Sonst waere die Erklaerung im
    englischen Storefront zur Haelfte deutsch.
  */
  function beschriftung(el) {
    if (!el) return '';
    var lab = el.id ? document.querySelector('label[for="' + el.id + '"]') : null;
    if (!lab) lab = el.closest('label');
    if (!lab) return '';
    // Das Pflicht-Sternchen gehoert nicht in die Erklaerung.
    return lab.textContent.replace(/[*\s]+$/, '').trim();
  }

  function erklaerungBauen(wurzel) {
    var ziel = wurzel.querySelector('[data-widerruf-erklaerung]');
    var scopeTeil = wurzel.querySelector('[data-widerruf-scope="teil"]');
    var teilweise = !!(scopeTeil && scopeTeil.checked);
    var positionen = wert(feld(wurzel, 'positionen'));
    var gewaehlt = wurzel.querySelector('[name="contact[Umfang]"]:checked');
    var zeilen = [];

    zeilen.push(ziel ? ziel.defaultValue.trim() : '');
    zeilen.push('');
    zeilen.push(teilweise && positionen ? positionen : (gewaehlt ? gewaehlt.value : ''));
    zeilen.push('');

    var reihen = ['name', 'vertrag', 'email', 'bestelldatum', 'erhalt'];
    for (var i = 0; i < reihen.length; i++) {
      var el = feld(wurzel, reihen[i]);
      var v = wert(el);
      if (reihen[i] === 'bestelldatum' || reihen[i] === 'erhalt') v = datumLesbar(v);
      if (v) zeilen.push(beschriftung(el) + ': ' + v);
    }

    var montage = feld(wurzel, 'montage');
    if (montage && montage.checked) zeilen.push(beschriftung(montage));

    return zeilen.join('\n');
  }

  function erklaerungKoppeln(wurzel) {
    var ziel = wurzel.querySelector('[data-widerruf-erklaerung]');
    if (!ziel) return;

    // Sobald der Verbraucher selbst tippt, gehoert der Text ihm — dann wird
    // nicht mehr ueberschrieben. `beruehrt` bleibt danach dauerhaft true.
    var beruehrt = false;
    ziel.addEventListener('input', function () {
      beruehrt = true;
    });

    function aktualisieren() {
      if (beruehrt) return;
      ziel.value = erklaerungBauen(wurzel);
    }

    wurzel.addEventListener('input', function (e) {
      if (e.target !== ziel) aktualisieren();
    });
    wurzel.addEventListener('change', function (e) {
      if (e.target !== ziel) aktualisieren();
    });
    aktualisieren();
  }

  /* ---------- 2. Teilwiderruf ---------- */

  function umfangKoppeln(wurzel) {
    var gruppe = wurzel.querySelector('[data-widerruf-umfang]');
    var block = wurzel.querySelector('[data-widerruf-positionen]');
    if (!gruppe || !block) return;

    function pruefen() {
      var teil = wurzel.querySelector('[data-widerruf-scope="teil"]');
      var an = !!(teil && teil.checked);
      block.hidden = !an;
      // `hidden` blendet nur aus; ohne `disabled` ginge ein alter Positions-
      // text weiter mit, waehrend die Erklaerung "gesamte Bestellung" sagt.
      var pos = feld(wurzel, 'positionen');
      if (pos) pos.disabled = !an;
    }

    gruppe.addEventListener('change', pruefen);
    pruefen();
  }

  /* ---------- 3. Kopie fuer die Unterlagen ---------- */

  function kopieMerken(wurzel, form) {
    form.addEventListener('submit', function () {
      var ziel = wurzel.querySelector('[data-widerruf-erklaerung]');
      if (!ziel) return;
      try {
        sessionStorage.setItem(
          SPEICHER,
          JSON.stringify({ text: ziel.value, zeit: new Date().toISOString() })
        );
      } catch (e) {
        // Storage gesperrt (privater Modus, Richtlinie): dann entfaellt nur
        // die Kopie. Der Widerruf selbst wird trotzdem abgesendet.
      }
    });
  }

  function zeitLesbar(iso) {
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    function zwei(n) {
      return n < 10 ? '0' + n : String(n);
    }
    return (
      zwei(d.getDate()) + '.' + zwei(d.getMonth() + 1) + '.' + d.getFullYear() +
      ', ' + zwei(d.getHours()) + ':' + zwei(d.getMinutes()) + ' Uhr'
    );
  }

  function kopieZeigen(wurzel) {
    var block = wurzel.querySelector('[data-widerruf-copy]');
    var textZiel = wurzel.querySelector('[data-widerruf-copy-text]');
    var fertig = wurzel.querySelector('[data-widerruf-done]');
    if (fertig) fertig.focus();
    if (!block || !textZiel) return;

    var roh = null;
    try {
      roh = sessionStorage.getItem(SPEICHER);
    } catch (e) {
      roh = null;
    }
    if (!roh) return;

    var daten;
    try {
      daten = JSON.parse(roh);
    } catch (e) {
      return;
    }
    if (!daten || !daten.text) return;

    var zeit = zeitLesbar(daten.zeit);
    var vorlage = block.getAttribute('data-widerruf-zeitzeile') || '';
    var voll = daten.text + (zeit && vorlage ? '\n\n' + vorlage.replace('%%ZEIT%%', zeit) : '');

    textZiel.textContent = voll;
    block.hidden = false;

    var runter = wurzel.querySelector('[data-widerruf-download]');
    if (runter) {
      runter.addEventListener('click', function () {
        datei(voll);
      });
    }
    var drucken = wurzel.querySelector('[data-widerruf-print]');
    if (drucken) {
      drucken.addEventListener('click', function () {
        window.print();
      });
    }
  }

  function datei(inhalt) {
    var blob = new Blob([inhalt], { type: 'text/plain;charset=utf-8' });
    var url = URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url;
    a.download = 'widerruf-kopie.txt';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }

  function start() {
    var alle = document.querySelectorAll('[data-widerruf]');
    for (var i = 0; i < alle.length; i++) init(alle[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
